<template>
    <div class="home-report">
      <VerifyAuthentication
          ref="verifyAuthRef"
          :screenNameProps="'CUSTOMER_REPORT'"
          style="display: none;"
      />
        <h1 class="page-title title d-flex justify-content-between">
          {{ $t('trs.front.title.tab.report') }}
          <div class="flex-center-justify flex-center-align">
            <a :href="$t('report.asked.questions.link')" target="_blank" class="show-popup-help">
              {{$t('report.asked.questions')}}
            </a>
          </div>
        </h1>
        <h4 class="box-title title ml-3">
            <span>{{ $t('trs.front.title.box.report') }}</span>
        </h4>
        <div class="alert alert-danger" v-if="message.errorMsgForVerify" v-html="$t(message.errorMsgForVerify, { supportLink: supportLink })">
        </div>

        <div class="alert alert-success alert-dismissible" role="alert" v-if="message.successMessage != null">
          <button type="button" id="btn-close" class="close btn-report-message-close" data-dismiss="alert" aria-label="Close" @click="removeMessage(IConstants.API_MESSAGE_TYPE.SUCCESS)">
            <span aria-hidden="true">&times;</span>
          </button>
          <div id="success-message" v-html="$t(message.successMessage)"></div>
        </div>

        <template v-if="isProcessing">
            <div class="page-ct">
                <div class="form-inline">
                  <div class="form-group" id="period-report">
                    <a class="btn btn-padding-lg font-label-custom" v-bind:class="isPeriodReport ? 'btn-success' :'btn-default'"
                       @click="changeReportTab(true)">{{ $t('report.label.period.report') }}</a>
                    <label id="tooltipbig-report-custom" title="" style="color: #82796D;position: relative;margin-left: 5px;margin-right: 5px">
                      <i class="fa fa-question-circle" id="fa-question-circle-report" style="font-size: 20px"></i>
                      <div class="tooltipbig-wrapper-custom report-tooltip">
                        <div>
                          <span>{{ $t('report.periodReportTextNote') }} </span><br>
                        </div>
                      </div>
                    </label>
                  </div>
                  <div class="form-group" style="margin-right: 0">
                    <a class="btn btn-padding-lg font-label-custom" v-bind:class="!isPeriodReport ? 'btn-success' :'btn-default'"
                       @click="changeReportTab(false)">{{ $t('report.label.day.month.year.report') }}</a>
                    <label>
                        <span id="tooltipbig-report2" title=""
                              style="color: #82796D;position: relative; margin-left: 5px">
                          <i class="fa fa-question-circle" style="font-size: 20px"></i>
                          <div class="tooltipbig-wrapper report-tooltip tooltip-report2-custom">
                            <div>
                              <span>{{ $t('report.textnote1') }}</span><br>
                              <span>{{ $t('report.textnote2') }}</span><br>
                              <span style="margin-left: 2%">{{ this.telephone }}</span><br>
                              <span>{{ $t('report.textnote3') }}</span><br>
                              <span>{{ $t('report.textnote4') }}</span><br>
                              <span>{{ $t('report.textnote5') }}</span><br>
                            </div>
                          </div>
                        </span>
                    </label>
                  </div>
                </div>
                <div class="page-meta">

                  <div class="row">
                    <span>{{ $t('report.label.period.and.pl.1')}}</span>
                  </div>
                  <div class="row">
                      <span v-html="$t('report.label.period.and.pl.2', {reportSupportLink : this.reportSupportLink})"></span>
                  </div>
                </div>
                <br><br><br>
                <div v-if="!isPeriodReport">
                    <div class="section">
                        <div class="box-ct">
                            <div class="news-filter">
                                <div class="alert alert-danger" v-if="model.errorMessage != null">
                                    {{ $t(model.errorMessage, {param0: $t(model.accountTypeLabel)}) }}
                                </div>
                                <form class="form-inline" id="downloadPdf">
                                    <label class="report-range first font-custom">{{ $t('report.label.period') }}</label>
                                    <div class="form-group d-flex flex-row">
                                        <div class="input-daterange input-group">
                                            <trs-date-picker v-model="dateStart"
                                                             :key="forceUpdateDateEndFlag"
                                                             class="form-date"
                                                             :yearLimit="10"
                                                             :toDate="dateEnd"/>

                                        </div>
                                        <span class="input-group-addon">~</span>
                                        <div class="input-daterange input-group">
                                            <trs-date-picker v-model="dateEnd"
                                                             class="form-date"
                                                             :yearLimit="10"
                                                             :fromDate="dateStart"/>
                                        </div>
                                    </div>
                                    <label class="report-range font-custom">{{ $t('report.label.type') }}</label>
                                    <div class="form-group" id="reportType">
                                        <dropdown-select classProps="ReportType"
                                                         :items="mapReportType"
                                                         @onSelect="reportType = $event"
                                                         :translate=true
                                                         :key="componentKey"
                                        ></dropdown-select>
                                    </div>
                                    <label class="report-range font-custom">{{ $t('report.table.account.type') }}</label>
                                    <div class="form-group" id="accountType">
                                        <dropdown-select classProps="AccountType"
                                                         :items="mapAccountTypeTransfers"
                                                         @onSelect="accountType = $event"
                                                         :translate=true
                                                         :key="componentKey"
                                        ></dropdown-select>
                                    </div>
                                    <div class="form-group pull-right btn-margin left-custom">
                                        <button class="btn btn-success ng-binding btn-padding-md"
                                                @click.prevent="searchReport(true, false)">{{ $t('report.label.search') }}
                                        </button>
                                    </div>
                                </form>
                                <span style="color: red" v-if="!this.profileState.maskingVerifiedPerSession">{{ $t('report.label.period.and.warn')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="section">
                        <table class="table table-striped table-hover table-bordered table-font-sm">
                            <thead>
                            <tr>
                                <th class="text-center">{{ $t('report.label.date') }}</th>
                                <th class="text-center">{{ $t('report.label.report_type') }}</th>
                                <th class="text-center">{{ $t('report.table.account.type') }}</th>
                                <th class="text-center">{{ $t('report.label.title') }}</th>
                                <th class="text-center">{{ $t('report.label.report_file') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-if="customerReportInfos && customerReportInfos.length > 0">
                                <tr v-for="item in customerReportInfos" :key="item.key">
                                    <td class="text-center">{{item.reportDate | formatDate('YYYYMMDD', 'YYYY/MM/DD')}}</td>
                                    <td class="text-center">{{ $t('report.cb.report.type.' + item.reportType) }}</td>
                                    <td class="text-center">{{ $t('report.table.account.type.' + item.accountType) }}</td>
                                    <td class="text-center">{{ item.reportTitle }}</td>
                                    <td class="text-center">
                                        <a href="#" @click="downloadFile(item.link, item.reportId, item.reportDate)">
                                            <i class="fas fa-file-pdf"></i>
                                        </a>
                                    </td>
                                </tr>
                            </template>
                            <tr>
                                <td colspan="5" v-if="infoMessage != null" class="nodata">
                                    {{ $t(infoMessage) }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group" style="text-align: center;">
                        <button type="button" class="btn btn-gray" @click="pageBack()" v-if="model.hasPrevious">
                            <i class="fas fa-caret-left"></i>
                        </button>
                        <button type="button" class="btn btn-gray disabled" v-if="!model.hasPrevious" disabled="disabled">
                            <i class="fas fa-caret-left"></i>
                        </button>
                        <button type="button" class="btn btn-gray" @click="pageNext()" v-if="model.hasNext">
                            <i class="fas fa-caret-right"></i>
                        </button>
                        <button type="button" class="btn btn-gray disabled" v-if="!model.hasNext" disabled="disabled">
                            <i class="fas fa-caret-right"></i>
                        </button>
                    </div>
                </div>

                <div v-if="isPeriodReport">
                    <div class="section">
                        <div class="box-ct">
                            <div class="news-filter">
                                <div class="alert alert-danger" v-if="model.errorMessage != null">
                                    {{ $t(model.errorMessage, {param0: $t(model.serviceTypeLabel)}) }}
                                </div>
                                <form class="form-inline" id="downloadPdfPeriod">
                                    <label class="report-range first font-custom">{{ $t('report.label.period') }}</label>
                                    <div v-if="!isPeriodCrypto" class="form-group d-flex flex-row" :key="componentKey">
                                        <div class="input-daterange input-group">
                                            <trs-date-picker v-model="dateStart"
                                                             class="form-date"
                                                             :yearLimit="2"
                                                             :disabledDate="`0,6`"
                                                             :isPeriodReport="isPeriodReport"
                                                             :key="forceUpdateDateEndFlag"
                                                             :toDate="dateEnd"/>
                                        </div>
                                        <span class="input-group-addon">~</span>
                                        <div class="input-daterange input-group">
                                            <trs-date-picker v-model="dateEnd"
                                                             class="form-date"
                                                             :yearLimit="2"
                                                             :disabledDate="`0,6`"
                                                             :isPeriodReport="isPeriodReport"
                                                             :key="forceUpdateDateStartFlag"
                                                             :fromDate="dateStart"/>
                                        </div>
                                    </div>
                                    <div v-if="isPeriodCrypto" class="form-group d-flex flex-row" :key="componentKey">
                                        <div class="input-daterange input-group">
                                            <trs-date-picker v-model="dateStart"
                                                             class="form-date"
                                                             :yearLimit="2"
                                                             :cryptoService="true"
                                                             :isPeriodReport="isPeriodReport"
                                                             :key="forceUpdateDateEndFlag"
                                                             :toDate="dateEnd"/>
                                        </div>
                                        <span class="input-group-addon">~</span>
                                        <div class="input-daterange input-group">
                                            <trs-date-picker v-model="dateEnd"
                                                             class="form-date"
                                                             :yearLimit="2"
                                                             :cryptoService="true"
                                                             :isPeriodReport="isPeriodReport"
                                                             :key="forceUpdateDateStartFlag"
                                                             :fromDate="dateStart"/>
                                        </div>
                                    </div>
                                    <label class="report-range font-custom">{{ $t('report.table.account.type') }}</label>
                                    <div class="form-group" id="serviceType">
                                        <dropdown-select classProps="ServiceType"
                                                         :items="mapAccountTypePeriodReport"
                                                         @onSelect="searchServiceType = $event"
                                                         :translate=false
                                                         :key="componentKey"
                                        ></dropdown-select>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-success ng-binding btn-padding-md font-label-custom"
                                                @click.prevent="searchPeriodReport">{{ $t('report.label.search') }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <template v-if="hasData">
                        <div class="form-group pull-right" v-if="periodReportInfo">
                            <button class="btn btn-primary ng-binding btn-padding-md" style="float: right"
                                    @click="downloadPeriodReport($event)">{{ $t('PDF') }}
                            </button>
                        </div>
                        <div v-if="serviceType === '0'">
                            <div class="tab-item active" id="tab-ams" style="display: block;">
                                <div class="tbl-table tbl-border" style="margin-bottom: 30px;">
                                    <div class="tbl-heading">
                                        <div class="tbl-cell" style="width: 50%;">{{ $t('label.cashBack') }}</div>
                                        <div class="tbl-cell">
                                            {{ $t('label.totalAmount') }}
                                        </div>
                                    </div>
                                    <div class="tbl-body">
                                        <div class="tbl-row" v-if="periodReportInfo">
                                            <div class="tbl-cell"></div>
                                            <div class="tbl-cell">{{ periodReportInfo.cashBack | moneyAmountFormat }}</div>
                                        </div>
                                        <div class="tbl-row nodata" v-if="infoMessage != null">
                                            <div class="tbl-cell"></div>
                                            <div class="tbl-cell">{{ $t(infoMessage) }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tbl-table tbl-border">
                                    <div class="tbl-heading">
                                        <div class="tbl-cell" style="width: 50%;">{{ $t('label.affiliate') }}</div>
                                        <div class="tbl-cell">
                                            {{ $t('label.totalAmount') }}
                                        </div>
                                    </div>
                                    <div class="tbl-body">
                                        <div class="tbl-row" v-if="periodReportInfo">
                                            <div class="tbl-cell"></div>
                                            <div class="tbl-cell">{{ periodReportInfo.affiliate | moneyAmountFormat }}</div>
                                        </div>
                                        <div class="tbl-row nodata" v-if="infoMessage">
                                            <div class="tbl-cell"></div>
                                            <div class="tbl-cell">{{ $t(infoMessage) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="serviceType === '4'">
                            <table class="table table-striped table-hover table-bordered table-font-sm">
                                <thead>
                                <tr>
                                    <th class="text-center">{{ $t('report.label.period.buy') }}</th>
                                    <th class="text-center">{{ $t('report.label.period.get') }}</th>
                                    <th class="text-center">{{ $t('report.table.period.total') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="row-read" v-if="periodReportInfo">
                                    <td>{{ periodReportInfo.buyAmount | moneyAmountFormat }}</td>
                                    <td>{{ periodReportInfo.getAmount | moneyAmountFormat }}</td>
                                    <td>{{ periodReportInfo.totalAmount | moneyAmountFormat }}</td>
                                </tr>
                                <tr>
                                    <td colspan="5" v-if="infoMessage != null" class="nodata">
                                        {{ $t(infoMessage) }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-if="periodReportInfo" class="title">
                                <p class="pull-left">{{ $t('report.label.period.totalRealizedPL') }}</p>
                                <p class="pull-right">{{ periodReportInfo.totalAmount | moneyAmountFormat }}</p>
                                <br>
                            </div>
                        </div>
                        <div class="scroll-table">
                            <div v-if="serviceType === '21' || serviceType ==='7' || serviceType === '31'">
                                <table class="table table-striped table-bordered text-center table-hover table-font-sm">
                                    <thead>
                                    <tr>
                                        <th class="text-left no-border-left-right-top" colspan="5">
                                            {{ $t('report.label.header.partSpotSwapPL') }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-center">{{ $t('report.label.period.spotPL') }}</th>
                                        <th v-if="serviceType === '31'" class="text-center">
                                            {{ $t('report.label.period.openInterestManagementFee') }}
                                        </th>
                                        <th v-if="serviceType === '21' || serviceType === '7'" class="text-center">
                                            {{ $t('report.label.period.swapPL') }}
                                        </th>
                                        <th class="text-center">{{ $t('report.label.period.adjustmentMoney') }}</th>
                                        <th class="text-center">{{
                                                serviceType === '31' || serviceType === '21' ?
                                                    $t('report.label.period.comissionFee') : $t('report.label.period.advisorFee')
                                            }}
                                        </th>
                                        <th class="text-center">{{ $t('report.table.period.total') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr class="row-read" v-if="periodReportInfo">
                                        <td>{{ periodReportInfo.spotPL | moneyAmountFormat }}</td>
                                        <td>{{ periodReportInfo.swapPL | moneyAmountFormat }}</td>
                                        <td>{{ periodReportInfo.adjustmentMoney | moneyAmountFormat }}</td>
                                        <td>{{ periodReportInfo.fee | moneyAmountFormat }}</td>
                                        <td>{{ periodReportInfo.total | moneyAmountFormat }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" v-if="infoMessage != null" class="nodata">
                                            {{ $t(infoMessage) }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div v-if="periodReportInfo" class="title">
                                    <p class="pull-left">{{ $t('report.label.period.totalRealizedPL') }}</p>
                                    <p class="pull-right">{{ periodReportInfo.totalRealizedPL | moneyAmountFormat }}</p>
                                    <br>
                                </div>

                                <div v-if="model.custReportSearchCondition.corporationType === 1">
                                    <br>
                                    <div class="scroll-table">
                                        <table class="table table-striped table-bordered text-center table-hover table-font-sm">
                                            <thead>
                                            <tr>
                                                <th class="text-left no-border-left-right-top" colspan="5">
                                                    {{ $t('report.label.period.UnRealized') }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th class="text-center"></th>
                                                <th class="text-center">{{ $t('report.label.period.UnRealized.spotPL') }}
                                                </th>
                                                <th v-if="serviceType === '31'" class="text-center">
                                                    {{ $t('report.label.period.unsettledOpenInterestManagementFee') }}
                                                </th>
                                                <th v-if="serviceType === '21' || serviceType === '7'" class="text-center">
                                                    {{ $t('report.label.period.UnRealized.swapPL') }}
                                                </th>
                                                <th class="text-center">{{ $t('label.total') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody v-if="periodReportInfo">
                                            <tr class="row-read">
                                                <td><b>{{ $t('label.begin') }}</b></td>
                                                <td>{{ periodReportInfo.beginningUnrealizedSpot || 0 | moneyAmountFormat }}
                                                </td>
                                                <td>{{ periodReportInfo.beginningUnrealizedSwap || 0 | moneyAmountFormat }}
                                                </td>
                                                <td>{{ periodReportInfo.beginningUnrealizedPL || 0 | moneyAmountFormat }}
                                                </td>
                                            </tr>
                                            <tr class="row-read">
                                                <td><b>{{ $t('label.end') }}</b></td>
                                                <td>{{ periodReportInfo.endingUnrealizedSpot || 0 | moneyAmountFormat }}
                                                </td>
                                                <td>{{ periodReportInfo.endingUnrealizedSwap || 0 | moneyAmountFormat }}
                                                </td>
                                                <td>{{ periodReportInfo.endingUnrealizedPL || 0 | moneyAmountFormat }}
                                                </td>
                                            </tr>
                                            <tr class="row-read">
                                                <td><b>{{ $t('label.increase/decrease') }}</b></td>
                                                <td>{{ periodReportInfo.totalUnrealizedSpot || 0 | moneyAmountFormat }}
                                                </td>
                                                <td>{{ periodReportInfo.totalUnrealizedSwap || 0 | moneyAmountFormat }}
                                                </td>
                                                <td>{{ periodReportInfo.totalUnrealizedPL || 0 | moneyAmountFormat }}
                                                </td>
                                            </tr>
                                            </tbody>
                                            <tbody v-if="infoMessage != null">
                                            <tr>
                                                <td colspan="5" class="nodata">
                                                    {{ $t(infoMessage) }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <table v-if="periodReportInfo"
                                           class="table table-striped table-bordered text-center table-hover table-font-sm table-width-50">
                                        <thead>
                                        <tr>
                                            <th class="text-left no-border-left-right-top" colspan="2">
                                                {{ $t('label.cashBack.square.brackets') }}
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="text-center"><b>{{ $t('label.total') }}</b></td>
                                            <td class="text-center">
                                                {{ periodReportInfo.totalCashback || 0 | moneyAmountFormat }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <br>
                                    <div v-if="periodReportInfo" class="title">
                                        <p v-if="serviceType === '31'" class="pull-left">
                                            {{ $t('report.label.period.total.cryptoUnRealized&&Realized') }}</p>
                                        <p v-if="serviceType === '21' || serviceType === '7'" class="pull-left">
                                            {{ $t('report.label.period.total.UnRealized&&Realized') }}</p>
                                        <p class="pull-right">
                                            {{ periodReportInfo.totalRealizedUnrealizedPL | moneyAmountFormat }}</p>
                                        <br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>


<script>
    import $ from "jquery";
    import moment from 'moment';
    import {GET_HEADER_INFO, MENU_HOME, SET_ACTIVE_TAB_ID} from "@/store/modules/header/type";
    import {createNamespacedHelpers} from "vuex";
    import Config from "@/services/Config";
    import {REPORT, ROOT} from "@/services/modules/_base";
    import 'isomorphic-fetch';
    import IConstants from "@/common/constants/IConstants";
    import ServiceUtils from "@/common/utils/ServiceUtils";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import postDocTemplateMixin from "@/common/mixins/postDocTemplate";
    import VerifyAuthentication from "@/common/mixins/VerifyAuthentication.vue";

    const domain = Config.getDomain();
    const {mapActions: mapHeaderActions} = createNamespacedHelpers('header');
    const {mapMutations: mapNewsMutations} = createNamespacedHelpers("news");
    const {mapState: mapProfileState} = createNamespacedHelpers("editProfile");

export default {
    components: {VerifyAuthentication},
    mixins: [
        postDocTemplateMixin
    ],
    data() {
        return {
            SERVICE_NAME: "report",
            customerReportInfos: [],
            infoMessage: null,
            periodReportInfo: null,
            corporationType: 0,
            data: {},
            model: this.initModel(),
            currentPage: 1,
            reportType: this.IConstants.ALL,
            accountType: this.IConstants.ACCOUNT_TYPE_TRANSFER.NTDFX,
            accountTypeLabel: "",
            mapReportType: [{
                key: this.IConstants.ALL,
                value: "default.combo.box",
                default: true
            }, ...this.IConstants.getMapReportType()],
            dateStart: null,
            dateEnd: null,
            dateStartSearch: null,
            dateEndSearch: null,
            isPeriodReport: true,
            isPeriodCrypto: false,
            hasData: false,
            inclusive: true,
            serviceType: this.IConstants.SERVICE_TYPE.NTD_FX,
            searchServiceType: this.IConstants.SERVICE_TYPE.NTD_FX,
            listPenultimateReportIds: [],
            maxPageSize: 10,
            componentKey: 0,
            accountTypeDownload: this.IConstants.ACCOUNT_TYPE_TRANSFER.NTDFX,
            message: {
                successMessage: null,
                errorMessage: null,
                errorMsgForVerify: null
            },
            isProcessing: false,
            supportLink: Config.getRegisterPasskeySupportLink(),
            reportSupportLink: Config.getReportSupportLink(),
            downloadReportData: null
        };
    },
    computed: {
        ...mapProfileState({
          profileState: state => state,
        }),
        mapAccountTypeTransfers() {
            let mapAccountTypeTransfers = this.IConstants.getMapAccountTypeTransfersAll();
            //set up default value to display when change report type tab
            mapAccountTypeTransfers.forEach(e => {
                if (e.key === this.IConstants.ACCOUNT_TYPE_TRANSFER.NTDFX) {
                    e.default = true
                }
            });

            return mapAccountTypeTransfers;
        },
        mapAccountTypePeriodReport() {
            let mapAccountTypeTransfers = this.IConstants.getMapAccountTypePeriodReport(false);
            //set up default value to display when change report type tab
            mapAccountTypeTransfers.forEach(e => {
                if (e.key === this.IConstants.SERVICE_TYPE.NTD_FX) {
                    e.default = true
                }
            });

            return mapAccountTypeTransfers;
        },
        forceUpdateDateStartFlag() {
            return this.dateStart;
        },
        forceUpdateDateEndFlag() {
            return this.dateEnd;
        },
    },
    watch: {
        searchServiceType(newValue, oldValue) {
            this.hasData = false;
            if (oldValue === "31" && newValue !== "31") {
                this.isPeriodCrypto = false;
                this.getDefaultDate();
            }
            if (oldValue !== "31" && newValue === "31") {
                this.isPeriodCrypto = true;
                this.getDefaultDate();
            }
            if (oldValue !== "31" && newValue !== "31") {
                this.isPeriodCrypto = false;
            }
            // for case click period tab to reset to service type FX -> select crypto service again.
            if (newValue === "31") {
                this.isPeriodCrypto = true;
                this.getDefaultDate();
            }
        },
    },
    methods: {
        ...mapHeaderActions([
            SET_ACTIVE_TAB_ID, 
            GET_HEADER_INFO
        ]),
        ...mapNewsMutations([
            'updateFields'
        ]),
        getDefaultDate() {
            const params = {
                'isPeriodReport': this.isPeriodReport,
                'isPeriodCrypto': this.isPeriodCrypto
            };
          const self = this;
          this.$service
                .getService(this.SERVICE_NAME)
                .getDefaultDate(params)
                .then((res) => {
                  this.$modal.reAssignProfileStateEvent({
                    authInfo: res.authenticateModel,
                    screenName: IConstants.SCREEN_NAME.CUSTOMER_REPORT
                  });
                  self.dateStart = res.fromDate;
                  self.dateEnd = res.toDate;
                  self.isProcessing = true;
                });
        },
        changeReportTab(isPeriodReport) {
            this.message.successMessage = null;
            this.componentKey++;
            this.isPeriodReport = isPeriodReport;
            this.hasData = false;
            this.model = this.initModel();
            this.resetForm();
            if (isPeriodReport) {
                this.searchServiceType = this.IConstants.SERVICE_TYPE.NTD_FX;
                this.isPeriodCrypto = false;
            } else {
                this.searchServiceType = this.IConstants.ALL;
            }
            this.getDefaultDate();
        },
        resetForm() {
            this.serviceType = this.IConstants.SERVICE_TYPE.NTD_FX;
            this.reportType = this.IConstants.ALL;
            this.accountType = this.IConstants.ACCOUNT_TYPE_TRANSFER.NTDFX;
            this.hasData = false;
            this.customerReportInfos = [];
            this.infoMessage = null;
        },
        searchReport(isBtnClick, isBack) {
            if (isBtnClick) {
                this.currentPage = 1;
            }
            this.getSearchParam();
            const self = this;
            if (!isBack) {
                if (this.currentPage > 1) {
                    if (this.model.hasNext) {
                        this.data['custReportSearchCondition.reportId'] = this.model.customerReportInfos[this.model.customerReportInfos.length - 2].reportId;
                    } else {
                        this.data['custReportSearchCondition.reportId'] = this.model.customerReportInfos[this.model.customerReportInfos.length - 1].reportId;
                    }
                }
            } else {
                if (this.currentPage === 2) {
                    this.data['custReportSearchCondition.reportId'] = this.listPenultimateReportIds[0];
                } else if (this.currentPage > 2) {
                    this.data['custReportSearchCondition.reportId'] = this.listPenultimateReportIds[this.currentPage - 2];
                }
            }
            this.data['index'] = this.currentPage;
            this.$service
                .getService(this.SERVICE_NAME)
                .initReport(this.data)
                .then((result) => {
                    self.model = result;
                    self.customerReportInfos = [];
                    self.$mount();
                    self.infoMessage = null;
                    if (result.errorMessage == null) {
                        if (result.customerReportInfos && result.customerReportInfos.length > 0) {
                            self.listPenultimateReportIds[this.currentPage - 1] = self.model.customerReportInfos[self.model.customerReportInfos.length - 1].reportId;
                            if (result.customerReportInfos.length > this.maxPageSize) {
                                for (let i = 0; i < this.maxPageSize; i++) {
                                    self.customerReportInfos[i] = result.customerReportInfos[i];
                                }
                            } else {
                                self.customerReportInfos = result.customerReportInfos;
                            }
                        } else {
                            self.infoMessage = result.infoMessage;
                        }
                    } else {
                        self.model.errorMessage = result.errorMessage;
                        self.model.accountTypeLabel = self.IConstants.getServiceTypeName(self.accountType, self.mapAccountTypeTransfers);
                        self.model.serviceTypeLabel = self.IConstants.getServiceTypeName(self.serviceType, self.mapAccountTypePeriodReport);
                        self.message.errorMsgForVerify = null;
                    }
                });
        },
        searchPeriodReport() {
            this.getSearchParam();
            this.dateStartSearch = this.dateStart;
            this.dateEndSearch = this.dateEnd;
            this.hasData = false;
            const self = this;
            this.$service
                .getService(this.SERVICE_NAME)
                .searchPeriodReport(this.data)
                .then((result) => {
                    self.model = result;
                    self.hasData = true;
                    self.serviceType = self.searchServiceType;
                    self.periodReportInfo = null;
                    self.infoMessage = null;
                    self.errorMessage = null;
                    if (result.errorMessage != null) {
                        self.model.serviceTypeLabel = self.IConstants.getServiceTypeName(self.serviceType, self.mapAccountTypePeriodReport);
                        self.model.errorMessage = result.errorMessage;
                        self.message.errorMsgForVerify = null;
                    } else {
                        if (result.periodReportInfo) {
                            self.periodReportInfo = result.periodReportInfo;
                        } else {
                            self.infoMessage = result.infoMessage;
                        }
                        self.model.errorMessage = null;
                        self.message.errorMsgForVerify = null;
                    }
                });
        },
        async downloadFile(link, reportId, reportDate) {
            let params = {
                'link': link,
                'reportId': reportId,
                'accountType': this.accountTypeDownload,
                'isWebkit': this.isWebview,
                'reportDate': reportDate
            };

            this.downloadReportData = {
              'isPeriodReport': false,
              'data': params
            }

            let config = {
                params: params,
                responseType: 'arraybuffer'
            };

            const self = this;
            const result = await this.$service.getService(this.SERVICE_NAME).verifyDownload(config)
            //need verify masking
            if (result.errorMsgForVerify) {
              if (this.$refs.verifyAuthRef) {
                await this.$refs.verifyAuthRef.clickVerifyBtn();
              }
              return;
            }

            self.model.errorMessage = result.errorMessage;
            if (result.errorMessage == null) {
              document.location = `${domain}/${ROOT}/${REPORT}/download-report?link=${link}&reportId=${reportId}&accountType=${this.accountTypeDownload}&isWebkit=${this.isWebview}&reportDate=${reportDate}`;
            } else {
              self.model.accountTypeLabel = IConstants.getServiceTypeName(self.accountType, self.mapAccountTypeTransfers);
            }
        },

        async downloadPeriodReport(event) {
          this.downloadReportData = {
            'isPeriodReport': true,
            'data': event
          }

          let dateStart = moment(new Date(this.dateStartSearch)).format('YYYYMMDD');
          let dateEnd = moment(new Date(this.dateEndSearch)).format('YYYYMMDD');
          const ERROR_MESSAGE = 'error-msg';
          const ERROR_MESSAGE_FOR_VERIFY = 'error-msg-verify';
          const KEY = 0;
          const VALUE = 1;
          const URL = `${domain}/${ROOT}/${REPORT}/download-period-report?serviceType=${this.serviceType}&reportDateFrom=${dateStart}&reportDateTo=${dateEnd}`;
          if (!event.detail || event.detail == 1) {
            fetch(URL)
                .then(async response => {
                  if (ServiceUtils.validateServerErrorHttpStatus(response.status)) {
                    return {
                      then: function () {
                      }
                    };
                  }

                  response.text().then(function (text) {
                    const data = ServiceUtils.parseStringJSON(text)
                    if (ServiceUtils.checkMaintainModeEOW(data)) {
                      return {
                        then: function () {
                        }
                      };
                    }
                  })

                  let isError = false;

                  for (let entry of response.headers.entries()) {
                    if (entry[KEY] === ERROR_MESSAGE) {
                      this.model.serviceTypeLabel = IConstants.getServiceTypeName(this.serviceType, this.mapAccountTypePeriodReport);
                      this.model.errorMessage = entry[VALUE];
                      this.message.errorMsgForVerify = null;
                      this.message.successMessage = null;
                      isError = true;
                      break;
                    }

                    if (entry[KEY] === ERROR_MESSAGE_FOR_VERIFY) {
                      isError = true;
                      if (this.$refs.verifyAuthRef) {
                        await this.$refs.verifyAuthRef.clickVerifyBtn();
                      }
                      break;
                    }
                  }

                  if (isError) {
                    return {
                      then: function () {
                      }
                    };
                  }

                  document.location = URL;
                })
          }

        },

        getSearchParam() {
            this.accountTypeDownload = this.accountType;
            this.data['custReportSearchCondition.reportDateFrom'] = moment(new Date(this.dateStart)).format('YYYYMMDD');
            this.data['custReportSearchCondition.reportDateTo'] = moment(new Date(this.dateEnd)).format('YYYYMMDD');
            if (this.data['custReportSearchCondition.reportDateFrom'] === moment(new Date(null)).format('YYYYMMDD')) {
                this.data['custReportSearchCondition.reportDateFrom'] = null;
            }
            if (this.data['custReportSearchCondition.reportDateTo'] === moment(new Date(null)).format('YYYYMMDD')) {
                this.data['custReportSearchCondition.reportDateTo'] = null;
            }
            this.data['custReportSearchCondition.accountType'] = this.accountType;
            this.data['custReportSearchCondition.reportType'] = this.reportType;
            this.data['custReportSearchCondition.serviceType'] = this.searchServiceType;
            this.data['custReportSearchCondition.inclusive'] = this.inclusive;
            if (this.currentPage == 1) {
                this.data['custReportSearchCondition.reportId'] = null;
            }
        },

        pageNext() {
            this.currentPage++;
            this.inclusive = false;
            this.searchReport(false, false);
        },
        pageBack() {
            this.currentPage--;
            this.inclusive = true;
            this.searchReport(false, true);
        },
        initModel() {
            return {
                hasNext: false,
                hasPrevious: false,
                errorMessage: null,
                successMessage: null
            }
        },
        removeMessage(messageType) {
          this.handleMessage(null, messageType);
        },
        handleMessage(message, messageType) {
          this.message = {};
          const {IConstants} = this;
          switch (messageType) {
            case IConstants.API_MESSAGE_TYPE.ERROR:
              this.message = {...this.message, errorMessage: message};
              break;
            case IConstants.API_MESSAGE_TYPE.SUCCESS:
              this.message = {...this.message, successMessage: message};
              break;
            case IConstants.API_MESSAGE_TYPE.WARNING:
              this.message = {...this.message, warnMessage: message};
              break;
          }
        },
        listenEvents() {
            ModalPlugin.EventBus.$on(IConstants.EVENT_NAME.SHOW_PROFILE_MESSAGE, async params => {
                if (params.message.successMessage) {
                    this.message.successMessage = params.message.successMessage;
                    this.message.errorMsgForVerify = null;
                    this.model.errorMessage = null;

                    if (this.downloadReportData) {
                        const {isPeriodReport, data} = this.downloadReportData;

                        if (isPeriodReport) {
                            await this.downloadPeriodReport(data)
                        } else {
                            await this.downloadFile(data.link, data.reportId, data.reportDate);
                        }
                    }
                }

                if (params.message.verifyAuthenticatorFailMsg) {
                    this.message.errorMsgForVerify = params.message.verifyAuthenticatorFailMsg;
                    this.model.errorMessage = null;
                    this.message.successMessage = null;
                }
                if (params.callBackFunc) params.callBackFunc()

                //reset data
                this.downloadReportData = null;
            });
        },
        unListenEvents() {
            ModalPlugin.EventBus.$off(IConstants.EVENT_NAME.SHOW_PROFILE_MESSAGE);
        }
    },

    async created() {
        this.getDefaultDate();
        this[SET_ACTIVE_TAB_ID](MENU_HOME);
        this[GET_HEADER_INFO]();
    },
    mounted() {
        $(window).bind("pageshow", function (event) {
            if (event.originalEvent.persisted) {
                window.location.reload();
            }
        });
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        this.listenEvents()
    },
    beforeDestroy() {
        this.unListenEvents()
    }
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
    .btn-margin {
        margin-left: 5px;
    }
}

@media screen and (max-width: 767px) {
    .news-filter {
        display: flex;
        flex-flow: column wrap;
    }

    .news-filter div {
        width: 100%;
    }

    #serviceType {
        margin-right: 0;
    }
}

@media screen and (min-width: 992px) {
    .left-custom{
        margin-left: auto;
    }
}

@media screen and (max-width: 979px) {
    .left-custom{
        margin-left: auto;
    }
}

.form-inline .form-group {
    margin-bottom: 15px;
}

.btn-padding-md {
    margin-left: 5px !important;
}

.news-filter {
    margin-bottom: 30px;
    margin-right: 0px;
}

.btn-padding-md {
    position: relative;
    right: 5px;
}

.input-group {
    border-collapse: separate;
}

.input-daterange {
    margin-left: -15px;
}

.no-border-left-right-top {
    border-top: hidden !important;
    border-left: hidden !important;
    border-right: hidden !important;
    border-bottom: 1px !important;
}

.pull-right {
    float: right !important;
}

.pull-left {
    float: left !important;
}

.report-tooltip {
    white-space: inherit !important;
    width: 308px;
}

.btn-gray {
    width: 50px;
    margin-right: 4px;
}

.report-range {
    margin-left: 5px;
    margin-bottom: 18px;
    padding: 6px 12px 0 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 1;
    color: #555555;
    text-align: center;
}

.first {
    margin-left: 0px !important;
    padding-left: 0px;
}

.input-daterange {
    padding-left: 15px;
}

.period-dropdown {
    min-width: 110px;
}

#serviceType {
    margin-right: 15px;
}
.font-custom{
    font-size: 12px;
}
.font-label-custom{
    font-size: 14px;
}

#tooltipbig-report-custom {
    cursor: pointer;
}
#tooltipbig-report-custom:hover .tooltipbig-wrapper-custom {
    display: block;
}
#tooltipbig-report-custom .tooltipbig-wrapper-custom {
    position: absolute;
    background: #fff;
    color: #333;
    display: none;
    white-space: nowrap;
    border: 1px solid #ededed;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    font-size: 13px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    right: -285px;
    z-index: 1000;
    bottom: 30px;
    line-height: 1.4;
    width: 395px;
}

#tooltipbig-report-custom .tooltipbig-wrapper-custom div:before {
    content: "";
    border: none;
    border-top: 6px solid #ffffff;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    display: inline-block;
    bottom: -5px;
    left: 50%;
    position: absolute;
    z-index: 1003;
}

#tooltipbig-report-custom .tooltipbig-wrapper-custom div:after {
    content: "";
    border: none;
    border-top: 7px solid #999999;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    bottom: -6px;
    left: 50%;
    position: absolute;
    z-index: 999;
}

#tooltipbig-report-custom .tooltipbig-wrapper-custom div{
    position:relative;
    padding:10px
}

@media screen and (max-width: 212px) {
    .tooltipbig-wrapper-custom {
        width: 126px !important;
        left: -4px !important;
    }

    .tooltipbig-wrapper-custom div:before {
        left: 5% !important;
    }

    .tooltipbig-wrapper-custom div:after {
        left: 5% !important;
    }

    #fa-question-circle-report {
        margin-top: 1px;
    }
}

@media screen and (min-width: 213px) and (max-width: 350px) {
    .tooltipbig-wrapper-custom {
        width: 186px !important;
        left: -163px !important;
    }

    .tooltipbig-wrapper-custom div:before {
        left: 89% !important;
    }

    .tooltipbig-wrapper-custom div:after {
        left: 89% !important;
    }
}

@media screen and (min-width: 351px) and (max-width: 767px) {
    .tooltipbig-wrapper-custom {
        width: 300px !important;
        left: -138px !important;
    }

    .tooltipbig-wrapper-custom div:before {
        left: 47% !important;
    }

    .tooltipbig-wrapper-custom div:after {
        left: 47% !important;
    }
}

@media screen and (min-width: 768px) {
    .tooltipbig-wrapper-custom {
        left: -195px !important;
        bottom: 30px !important;
    }
}

@media screen and (max-width: 273px) {
    .tooltipbig-wrapper {
        width: 196px !important;
        left: -14px !important;
        top: 24px !important;
    }

    .tooltipbig-wrapper div:before {
        left: 10% !important;
    }

    .tooltipbig-wrapper div:after {
        left: 10% !important;
    }
}

@media screen and (min-width: 274px) and (max-width: 316px) {
    .tooltipbig-wrapper {
        width: 260px !important;
    }

    .tooltipbig-wrapper div:before {
        left: 89% !important;
    }

    .tooltipbig-wrapper div:after {
        left: 89% !important;
    }
}

@media screen and (min-width: 274px) and (max-width: 614px) {
    .tooltipbig-wrapper {
        top: 30px !important;
    }
}

.second-pwd-note {
    font-size: 14px;
    display: inline-block;
    margin: 14px 0 14px 0;
}

#success-message {
    width: 90%;
}

.btn-report-message-close {
    width: 10%;
}

.show-popup-help {
  display: inline-block;
  background-color: #ff9900;
  border: 3px solid #ff9900;
  padding: 7px;
  color: #ffffff;
  font-size: 12px;
  float: right;
  border-radius: 20px;
}
.show-popup-help:hover {
  background-color: #ffffff;
  border: 3px solid #ff9900;
  color: #ff9900;
}
</style>
